import { type FC, useCallback, useState } from "react";

import { SelectLanguage } from "./gameComponents/SelectLanguage";
import { GameContainer } from "./GameContainer";
import type { Language } from "./types";

import './MainContainer.css';

export const MainContainer: FC = () => {
    const [isLanguageSelected, setIsLanguageSelected] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState<Language>("lv")
    const [resultsVisible, setResultsVisible] = useState(false);

    const mainContainerClassName = resultsVisible ? "mainContainer resultsVisible" : "mainContainer";
    const handleSetResultsVisible = useCallback((visible: boolean) => {
        setResultsVisible(visible)
    },[]);
    return (
        <div className={mainContainerClassName}>
            {isLanguageSelected
                ? <GameContainer
                    language={selectedLanguage}
                    onBackClick={()=> setIsLanguageSelected(false)}
                    setResultsVisibleCallback={(visible: boolean) => handleSetResultsVisible(visible)}
                />
                : <SelectLanguage
                    setIsLanguageSelected={setIsLanguageSelected}
                    setLanguage={setSelectedLanguage}
                />
            }
        </div>
    )  
}
